import React from 'react';
import ScmIconTab from './ScmIconTab';
import { useTheme, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';

const TabsIconSelector = ({
  tabs,
  selectedIndex,
  onSelect,
  selectedIconBarColor,
}) => {
  const theme = useTheme();
  const showBreadCrumbs = useMediaQuery(theme.breakpoints.down('lg'));

  let maxVisibleIcons = tabs.length;
  if (showBreadCrumbs) maxVisibleIcons = 3;

  let start = 0;
  if (showBreadCrumbs && tabs.length > 3) {
    if (selectedIndex < 1) start = 0;
    else if (selectedIndex > tabs.length - 3) start = tabs.length - 3;
    else start = selectedIndex - 1;
  }
  const visibleTabs = showBreadCrumbs
    ? tabs.slice(start, start + maxVisibleIcons)
    : tabs.slice(0, maxVisibleIcons);

  return (
    <ScmTabSelectorWrapper>
      <ScmIconTabsWrapper>
        {visibleTabs.map((tab, idx) => (
          <ScmIconTab
            key={tab?.fields?.iconImage?.label || start + idx}
            tab={tab}
            index={start + idx}
            selectedIndex={selectedIndex}
            onSelect={onSelect}
            selectedIconBarColor={selectedIconBarColor}
          />
        ))}
      </ScmIconTabsWrapper>
      {showBreadCrumbs && (
        <BreadcrumbWrapper>
          {tabs.map((_, idx) => (
            <Breadcrumb
              key={idx}
              selected={idx === selectedIndex}
              onClick={() => onSelect(idx)}
            />
          ))}
        </BreadcrumbWrapper>
      )}
    </ScmTabSelectorWrapper>
  );
};

const ScmTabSelectorWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 0,
  marginTop: -20.5,
  marginLeft: 5,
  marginRight: 5,
  '@media (max-width: 600px) and (orientation: landscape)': {
    gap: 6,
    marginTop: 0,
    marginLeft: 0,
    marginRight: 0,
    maxWidth: '568px',
  },
  '@media (max-width: 430px) and (orientation: landscape)': {
    gap: 6,
    marginTop: 0,
    marginLeft: 0,
    marginRight: 0,
    maxWidth: '430px',
  },
  [theme.breakpoints.down('md')]: {
    gap: 10,
    marginTop: 0,
  },
}));
const ScmIconTabsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  gap: 0,
  [theme.breakpoints.down('md')]: {
    gap: 50,
  },
}));

const BreadcrumbWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: 40,
  '@media (max-width: 600px) and (orientation: landscape)': {
    marginTop: 20,
  },
  '@media (max-width: 430px) and (orientation: landscape)': {
    marginTop: 5,
  },
  [theme.breakpoints.down('md')]: {
    marginTop: 20,
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: -20,
  },
}));

const Breadcrumb = styled('div')(({
  width: 16,
  height: 16,
  borderRadius: '50%',
  backgroundColor: '#e0e0e0',
  margin: '0 6px',
  cursor: 'pointer',
  display: 'inline-block',
  border: '2px solid #e0e0e0',
  transition: 'background 0.3s',
  variants: [{
    props: (
      {
        selected
      }
    ) => selected,
    style: {
      backgroundColor: '#1976d2'
    }
  }, {
    props: (
      {
        selected
      }
    ) => selected,
    style: {
      border: '2px solid #1976d2'
    }
  }]
}));

export default TabsIconSelector;
